function num(s) {
  return s < 10 ? '0' + s : s;
}

/**
 * 转换时间 eg: 11:20:20
 * @param {*} time
 * @return { String }
 */
export const dateTimeHms = (time) => {
  if (!time) return '';
  let dateTime = '';
  let hours = num(Number.parseInt(time / 3600));
  let minutes = num(Number.parseInt((time % 3600) / 60));
  let seconds = num(Number.parseInt(time % 60));
  dateTime = `${hours}:${minutes}:${seconds}`;
  return dateTime;
};
